<template>
  <div class="input-select">
    <div class="selector" :class="{ show: showed }">
      <div v-for="(item, key) in items" :key="key" class="item" @click="change(item, key)">
        <slot name="item" :item="item" :id="key">{{ item }}</slot>
      </div>
      <div v-if="empty" class="item" @click="hide">---</div>
    </div>
    <div class="label" :class="{ disabled: disabled }" @click="toggle">
      <slot name="label"></slot>
    </div>
  </div>
</template>

<script>
import { events } from "../extend";

export default {
  name: "dropdown",
  props: {
    items: {},
    disabled: { default: false }
  },
  data: () => ({
    showed: false
  }),
  computed: {
    empty() {
      if (Array.isArray(this.items)) {
        return this.items.length == 0;
      }

      return Object.keys(this.items).length == 0;
    }
  },
  methods: {
    change(value, key) {
      if (this.disabled) return;

      this.$emit("change", value, key);
      this.hide();
    },
    toggle() {
      if (this.disabled) return;
      
      this.showed = !this.showed;
    },
    hide() {
      this.showed = false;
    }
  },
  mounted() {
    events.closer(this.$el, this.hide);
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.input-select
  @include inputer-select()
</style>